import { useTranslation } from "react-i18next"

const ProductOperation = props => {
    const { t } = useTranslation()
    return <div className="App">
    </div>
}

export default ProductOperation